import axios from "axios";
import { OrganizationURL, SuperAdminURL } from "../../../../config/UrlEndPoint";

export const URL = `${SuperAdminURL}organization/features`;
export const ORG_URL = `${OrganizationURL}organization/features`;

// Get OrganizationFeature All
export function getOrganizationFeatureAll() {
  return axios.get(URL);
}

// * GET DEFAULT FEATURE
export function getOrgDefaultFeature() {
  return axios.get(`${URL}/default`);
}

// * FIND BLACKLIST FEATURE
export function findOrganizationFeatures() {
  return axios({ method: "GET", url: URL });
}

export function findCurrentOrganizationFeatures() {
  return axios({ method: "GET", url: ORG_URL });
}

// * UPDATE Multiple Features
export function updateOrganizationFeatures(payload) {
  return axios({ method: "PUT", url: `${URL}/`, data: payload });
}

// * FIND ALL BLACKLIST FEATURE
export function findAllBlackListFeature() {
  return axios.get(`${URL}/getAll`);
}

// * GET ONE BLACKLIST FEATURE
// export function getOneBlackListFeature(payload) {
//   return axios.post(`${URL}/get_one_feature`, payload);
// }
